
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useFormContext } from 'react-hook-form';

export const TeachingInfoFields: React.FC = () => {
  const { control } = useFormContext();

  return (
    <>
      <FormField
        control={control}
        name="teaching_type"
        render={({ field }) => (
          <FormItem>
            <FormLabel>ประเภทการสอน</FormLabel>
            <Select
              onValueChange={field.onChange}
              defaultValue={field.value}
              value={field.value || ''}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="เลือกประเภทการสอน" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="Private มีชีท = คุณครูใช้ชีทตัวเอง">
                  Private มีชีท = คุณครูใช้ชีทตัวเอง
                </SelectItem>
                <SelectItem value="Private ไม่มีชีท = คุณครูใช้ชีทของสถาบัน (ชีทภาษาไทย)">
                  Private ไม่มีชีท = คุณครูใช้ชีทของสถาบัน (ชีทภาษาไทย)
                </SelectItem>
                <SelectItem value="Premier_TH ไม่มีชีท = คุณครูใช้ชีทของสถาบัน">
                  Premier_TH ไม่มีชีท = คุณครูใช้ชีทของสถาบัน
                </SelectItem>
                <SelectItem value="Premier_TH มีชีท = คุณครูใช้ชีทตัวเอง/ชีทน้อง (ชีทภาษาไทย)">
                  Premier_TH มีชีท = คุณครูใช้ชีทตัวเอง/ชีทน้อง (ชีทภาษาไทย)
                </SelectItem>
                <SelectItem value="Premier_Inter ไม่มีชีท = คุณครูใช้ชีทของสถาบัน (ชีทภาษาอังกฤษ)">
                  Premier_Inter ไม่มีชีท = คุณครูใช้ชีทของสถาบัน (ชีทภาษาอังกฤษ)
                </SelectItem>
                <SelectItem value="Premier_Inter มีชีท = คุณครูใช้ชีทตัวเอง/ชีทน้อง (ชีทภาษาอังกฤษ)">
                  Premier_Inter มีชีท = คุณครูใช้ชีทตัวเอง/ชีทน้อง (ชีทภาษาอังกฤษ)
                </SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
